import { Link, useNavigate } from "react-router-dom";
import { XCircle, Home, RefreshCw, ArrowRight } from "lucide-react";
import { PageShell, PageHero } from "@/components/site-layout";

export default function PaymentFailedPage() {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const reference = params.get('reference') || 'Unknown';

  return (
    <PageShell>
      <PageHero
        eyebrow="Payment"
        title={<>Payment <span className="gradient-text">Failed</span></>}
        intro="Your payment could not be processed. Please try again or contact our admissions team for assistance."
      />

      <section className="container-x pb-24 pt-12">
        <div className="mx-auto max-w-lg rounded-3xl border border-border bg-card p-10 text-center shadow-[var(--shadow-elegant)] animate-fade-up">
          <div className="mx-auto grid h-20 w-20 place-items-center rounded-full bg-destructive/10 text-destructive">
            <XCircle className="h-10 w-10" />
          </div>
          <h1 className="mt-6 text-3xl font-bold">Payment Failed</h1>
          <p className="mt-3 text-muted-foreground">
            We couldn't process your payment. This could be due to a network issue or insufficient funds.
          </p>
          <div className="mt-4 rounded-lg bg-muted p-4 text-left">
            <p className="text-sm font-medium">Reference: {reference}</p>
            <p className="text-xs text-muted-foreground mt-1">
              Please save this reference for support inquiries.
            </p>
          </div>
          <div className="mt-8 flex flex-col gap-3">
            <button
              onClick={() => navigate("/register")}
              className="btn-primary"
            >
              <RefreshCw className="h-4 w-4" /> Try Again
            </button>
            <button
              onClick={() => window.location.href = "mailto:Institute@revocubelinks.com?subject=Payment Failed - " + reference}
              className="btn-ghost"
            >
              <ArrowRight className="h-4 w-4" /> Contact Support
            </button>
            <button
              onClick={() => navigate("/")}
              className="btn-ghost"
            >
              <Home className="h-4 w-4" /> Return to Home
            </button>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
